import * as React from "react";

import { faFileXls } from "@fortawesome/pro-solid-svg-icons";
import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconExcel: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faFileXls} />;
};
